import React from "react";

import SubscribeSection from "../../components/SubscribeSection";
import Footer from "../../components/Footer";
import Hero from "../../components/hero/Hero";

const Home = () => {
  return (
    <>
      <Hero />

      <SubscribeSection />
      <Footer />
    </>
  );
};

export default Home;
